// extracted by mini-css-extract-plugin
export default {"wrapper":"Products_wrapper__+osP0"};